var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"template-charts-area"},[_vm._t("default",function(){return _vm._l((4),function(i){return _c('div',{key:i,staticClass:"chart-placeholder"},[_c('div',{staticClass:"chart-label"},[_vm._v("차트 영역 "+_vm._s(i))]),_c('div',{staticClass:"chart-content"},[_vm._v("차트 내용을 여기에 표시합니다")])])})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }